import { Stack, Box, Divider, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import useMobile from '@/hooks/useMobile';
import Iconify from '@/components/Iconify';
import { concatenateArray } from '@/utils/miscellaneous';
import getColorPresets from '@/utils/getColorPresets';
import useEventContext from '@/contexts/event/useEventContext';
import { formatLocalDate } from '@/locales/dates';
import { useMsci } from '@/store';

export default function MsiPreSale() {
  const { t } = useTranslation();
  const { isMobile } = useMobile();
  const { msci: msi } = useMsci();
  const blue = getColorPresets('blue');
  const {
    event: {
      event: { activated_at },
    },
  } = useEventContext();

  return (
    <Box
      sx={{
        boxShadow: (theme) => theme.customShadows.z8,
        mt: isMobile ? 1 : 2,
        mb: isMobile ? 1 : 2,
        border: (theme) => `0.5px solid ${theme.palette.grey[200]}`,
        borderRadius: '16px',
      }}
    >
      <Stack
        direction="row"
        spacing={2}
        sx={{
          width: '100%',
          marginTop: '16px',
          marginBottom: '8px',
        }}
      >
        <Box
          sx={{
            width: '20px',
            height: '20px',
            ml: isMobile ? 1 : 2,
            color: (theme) => theme.palette.orange[0],
            pt: 0.5,
          }}
        >
          <Iconify
            width={20}
            height={20}
            icon={'material-symbols:star-outline'}
          />
        </Box>
        <Box>
          <Typography
            variant="body2"
            component="div"
            sx={{
              fontWeight: 600,
            }}
          >
            {`${t('checkout.msi.preSaleLow')} ${`${concatenateArray(
              Object.keys(msi.preSale?.banks || {}),
            )}`}`}
          </Typography>
          <Typography
            variant="body2"
            component="div"
            sx={{
              fontWeight: 400,
            }}
          >
            {formatLocalDate(msi.preSale.startAt, {
              time: 'HH:mm A',
            })}
          </Typography>
        </Box>
      </Stack>
      <Divider />
      <Stack
        direction="row"
        spacing={2}
        sx={{
          width: '100%',
          marginTop: '16px',
          marginBottom: '8px',
        }}
      >
        <Box
          sx={{
            width: '20px',
            height: '20px',
            ml: isMobile ? 1 : 2,
            color: blue.light,
            pt: 0.5,
          }}
        >
          <Iconify
            width={20}
            height={20}
            icon={'mdi:ticket-confirmation-outline'}
          />
        </Box>
        <Box>
          <Typography
            variant="body2"
            component="div"
            sx={{
              fontWeight: 600,
            }}
          >
            {`${t('checkout.msi.preSaleLow')} ${`${concatenateArray(
              Object.keys(msi.preSale?.banks || {}),
            )}`}`}
          </Typography>
          <Typography
            variant="body2"
            component="div"
            sx={{
              fontWeight: 400,
            }}
          >
            {formatLocalDate(activated_at, {
              time: 'HH:mm A',
            })}
          </Typography>
        </Box>
      </Stack>
    </Box>
  );
}
